export const defaultAiPrivacySettings = {
  aiRecommendations: true,
  aiRiskAlerts: true,
  aiExternalProcessingEnabled: true,
  aiMaskCustomerData: true,
  aiHighPrivacyMode: true,
  aiFullDetailMode: false,
};

export function loadAiPrivacySettings() {
  try {
    const raw = localStorage.getItem("spacem8_settings");
    if (!raw) return defaultAiPrivacySettings;

    const parsed = JSON.parse(raw);
    return {
      ...defaultAiPrivacySettings,
      aiRecommendations: parsed.aiRecommendations ?? defaultAiPrivacySettings.aiRecommendations,
      aiRiskAlerts: parsed.riskAlerts ?? defaultAiPrivacySettings.aiRiskAlerts,
      aiExternalProcessingEnabled:
        parsed.aiExternalProcessingEnabled ?? defaultAiPrivacySettings.aiExternalProcessingEnabled,
      aiMaskCustomerData:
        parsed.aiMaskCustomerData ?? defaultAiPrivacySettings.aiMaskCustomerData,
      aiHighPrivacyMode:
        parsed.aiHighPrivacyMode ?? defaultAiPrivacySettings.aiHighPrivacyMode,
      aiFullDetailMode:
        parsed.aiFullDetailMode ?? defaultAiPrivacySettings.aiFullDetailMode,
    };
  } catch (_error) {
    return defaultAiPrivacySettings;
  }
}

export function canUseFullDetailAi(role) {
  return role === "Administrator" || role === "Growth";
}

export function resolveAiPrivacyMode(settings, role) {
  if (!settings.aiExternalProcessingEnabled) {
    return {
      useExternalAi: false,
      mode: "local-only",
      maskCustomerData: true,
    };
  }

  const allowFullDetail = canUseFullDetailAi(role) && settings.aiFullDetailMode;

  return {
    useExternalAi: true,
    mode: allowFullDetail
      ? "full-detail"
      : settings.aiHighPrivacyMode
      ? "high-privacy"
      : settings.aiMaskCustomerData
      ? "masked"
      : "standard",
    maskCustomerData: allowFullDetail ? false : settings.aiMaskCustomerData,
    highPrivacyMode: allowFullDetail ? false : settings.aiHighPrivacyMode,
  };
}
